import { render } from "./SharingButton.vue?vue&type=template&id=1d28a2f8&scoped=true&ts=true&lang=pug"
import script from "./SharingButton.vue?vue&type=script&lang=ts"
export * from "./SharingButton.vue?vue&type=script&lang=ts"

import "./SharingButton.vue?vue&type=style&index=0&id=1d28a2f8&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d28a2f8"]])

export default __exports__